import React from 'react';

import { MotionPlayer } from '@af/design-system-docs-ui/motion-player';
import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Grid, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import DropdownAnimation from '../_assets/_lottie/dropdown.json';
import ModalAnimation from '../_assets/_lottie/modal.json';

const styles = cssMap({
	root: {
		/* Single column on mobile, two columns from 30rem up. */
		gridTemplateColumns: '1fr',
		'@media (min-width: 30rem)': {
			gridTemplateColumns: '1fr 1fr',
		},
		paddingBlockStart: token('space.400'),
		paddingBlockEnd: token('space.400'),
	},
});

/**
 * Grid of transition `MotionPlayer`s with labels and descriptions.
 */
const Transitions = (): React.JSX.Element => {
	return (
		<Grid testId="grid-basic" xcss={styles.root} rowGap="space.150" columnGap="space.150">
			<Stack space="space.100">
				<Heading size="xsmall">Dropdown entrance, 150ms</Heading>
				<MotionPlayer
					source="lottie"
					lottieFile={DropdownAnimation}
					size="small"
					hasSpacing={false}
					label="Cursor clicking a Dropdown menu sliding down from its 'Create' trigger."
				/>
			</Stack>
			<Stack space="space.100">
				<Heading size="xsmall">Modal entrance, 250ms</Heading>
				<MotionPlayer
					source="lottie"
					lottieFile={ModalAnimation}
					size="small"
					hasSpacing={false}
					label="Cursor triggering a Modal dialog centred on screen."
				/>
			</Stack>
		</Grid>
	);
};

export default Transitions;
